import { message } from 'antd'

export interface PasswordGeneratorOptions {
  length?: number
  includeUpper?: boolean
  includeLower?: boolean
  includeDigits?: boolean
  includeSpecial?: boolean
}

const DEFAULT_OPTIONS: Required<PasswordGeneratorOptions> = {
  length: 10,
  includeUpper: true,
  includeLower: true,
  includeDigits: true,
  includeSpecial: true,
}

/**
 * Custom hook để generate mật khẩu ngẫu nhiên
 */
export const usePasswordGenerator = (options?: PasswordGeneratorOptions) => {
  const config = { ...DEFAULT_OPTIONS, ...options }

  const generatePassword = (): string => {
    const lower = 'abcdefghijkmnopqrstuvwxyz'
    const upper = 'ABCDEFGHJKLMNPQRSTUVWXYZ'
    const digits = '23456789'
    const special = '!$#@&%~'

    let chars = ''
    let password = ''

    // Thêm các ký tự vào pool dựa trên config
    if (config.includeLower) chars += lower
    if (config.includeUpper) chars += upper
    if (config.includeDigits) chars += digits
    if (config.includeSpecial) chars += special

    if (chars.length === 0) {
      throw new Error('Phải chọn ít nhất một loại ký tự')
    }

    // Đảm bảo mỗi loại có ít nhất 1 ký tự (nếu được bật)
    if (config.includeUpper) {
      password += upper[Math.floor(Math.random() * upper.length)]
    }
    if (config.includeLower) {
      password += lower[Math.floor(Math.random() * lower.length)]
    }
    if (config.includeDigits) {
      password += digits[Math.floor(Math.random() * digits.length)]
    }
    if (config.includeSpecial) {
      password += special[Math.floor(Math.random() * special.length)]
    }

    // Random phần còn lại
    for (let i = password.length; i < config.length; i++) {
      password += chars[Math.floor(Math.random() * chars.length)]
    }

    // Shuffle để các ký tự bắt buộc không nằm ở đầu
    password = password
      .split('')
      .sort(() => Math.random() - 0.5)
      .join('')

    return password
  }

  const copyToClipboard = async (text: string): Promise<boolean> => {
    if (!text) {
      message.warning('Chưa có mật khẩu để sao chép')
      return false
    }

    try {
      await navigator.clipboard.writeText(text)
      message.success('Đã sao chép mật khẩu!')
      return true
    } catch (err) {
      message.error('Không thể sao chép mật khẩu')
      return false
    }
  }

  return {
    generatePassword,
    copyToClipboard,
  }
}
